import React, { useCallback, useEffect, useRef, useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "./ListingRail.css";

/** A swipeable row of listing cards with prev / next arrows on desktop (used under the product: Related + Recently viewed). */
export default function ListingRail({ children, label }) {
  const track = useRef(null);
  const [edge, setEdge] = useState({ start: true, end: true });

  const measure = useCallback(() => {
    const el = track.current; if (!el) return;
    setEdge({ start: el.scrollLeft < 8, end: el.scrollLeft + el.clientWidth >= el.scrollWidth - 8 });
  }, []);
  useEffect(() => { measure(); window.addEventListener("resize", measure); return () => window.removeEventListener("resize", measure); }, [measure, children]);
  const go = (dir) => { const el = track.current; if (el) el.scrollBy({ left: dir * Math.max(260, el.clientWidth * 0.85), behavior: "smooth" }); };

  return (
    <div className="lr" role="region" aria-label={label}>
      {!edge.start && <button type="button" className="lr-arrow lr-l" onClick={() => go(-1)} aria-label="Previous"><FaChevronLeft /></button>}
      <div className="lr-track" ref={track} onScroll={measure}>{children}</div>
      {!edge.end && <button type="button" className="lr-arrow lr-r" onClick={() => go(1)} aria-label="Next"><FaChevronRight /></button>}
    </div>
  );
}
